module.exports = __webpack_public_path__ + "img/e.e6780740.jpg";